(function () {
  'use strict';

  angular
    .module('unit.interested.leads')
    .factory('UnitInterestedLeads', UnitInterestedLeads);

  UnitInterestedLeads.$inject = ['$resource'];

  function UnitInterestedLeads($resource) {
    return $resource(
      '/api/unit',
      {},
      {
        get: {
          method: 'GET',
          url: '/api/unit/:id/interested_leads',
          isArray: true,
        },
        create: { method: 'POST', url: '/api/lead/create' },
        update: { method: 'POST', url: '/api/lead/:id/update' },
        getLeadStatuses: {
          method: 'GET',
          url: '/api/lead/status',
          isArray: true,
          cache: true,
        },
      },
    );
  }
})();
